export default __webpack_public_path__ + "static/pic-1-8bca4d05370dfeb3216d375681d8cdde.png";